import axios from 'axios';
import { API_URL } from '../../services/apiUrl';

const api = axios.create({ baseURL: `${API_URL}/tictactoe` });

export const requestMove = (payload) => api.post('/move', payload).then(({ data }) => data);
